"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/marketing/fortune/product");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FortuneProductConfig',
  data: function data() {
    return {
      loading: false,
      typeOptions: [{
        label: '佣金',
        value: 1
      }],
      formData: {
        newUserCashAmount: 0,
        newUserPoints: 0,
        walletRangeConfigs: []
      },
      products: [],
      rules: {}
    };
  },
  created: function created() {
    this.getConfigInfo();
  },
  methods: {
    // 获取配置信息
    getConfigInfo: function getConfigInfo() {
      var _this = this;
      this.loading = true;
      (0, _product.getFortuneProductsApi)().then(function (data) {
        _this.products = data;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSubmit: function handleSubmit(name) {
      this.postData();
      // this.$refs[name].validate((valid, obj) => {
      //   if (valid) {
      //
      //   } else {
      //     for (const key in obj) {
      //       const msg = obj[key][0].message;
      //       return this.$message.warning(msg);
      //     }
      //   }
      // });
    },
    getFormData: function getFormData() {
      return {
        products: _toConsumableArray(this.products)
      };
    },
    // 新增保存数据
    postData: function postData() {
      var _this2 = this;
      this.loading = true;
      var data = this.getFormData();
      (0, _product.updateFortuneProductsApi)(data).then(function (data) {
        _this2.$message.success('保存成功');
      }).finally(function (err) {
        _this2.loading = false;
      });
    }
  }
};